
import { Applicant } from "./applicant-model";
import { Credit } from './credit.model';

export class QUOTE_APPLICATION{
  id?: number;
  status:string;
  referenceNumber?:string;
  caseNumber?: string;
  category?: string;
  applicantId?: number;
  applicant?: Applicant;
  bctContact?: string;
  developmentName?: string;
  developmentType?: string; 
  developmentTypeId?:number;
  lgaid?: number;
  lga?: string;
  obligationType?:string;
  nswobligationReference?:string;
  commonwealthObligationReference?: string;
  geographicRegion?: string;
  submittedDate?: string;
  issuedDate?: string;
  quoteIssueDueDate?: string;
  quoteIssueDueDateMet?: string;
  adjustedIssueDueDate?: string;
  adjustedDueDateReason?:string
  quoteIssueDate?: string;
  expiryDate?:string;
  cancelReason?: string;
  quoteCancelReason?: string;
  queryReason?: string;
  queryReasonFlag?: number;
  adjustedExpiryDate?:string;
  adjustedExpiryDateReason?:string;
  applicationIncompleteReason?:string;
  queryEmailDateSent?:string;
  queryEmailResponseDueDate?:string;
  queryEmailAdjustedResponseDueDate?:string;
  cm9reference?: string;
  cm9ContainerID?:string;
  authoriserName?:string;
  authoriserPosition?:string;
  authoriserOrganisation?:string;
  authorisationOption?: string;
  quoteCredits?: any;
  quoteFiles?: any;
  quoteReviews?: any;
  reviewCompleteDate?: string;
  cancelApplicationMailSentDate?: string;
  cancelQuoteMailSentDate?: string;
  incompleteMailSentDate?: string;
  obligationPayments?: any = [];
  bcfPaymentReference: string;
  allowPermissionToUser?: number;
  permittedToUserName?: string;
  public constructor() {
    this.applicant = {};
    };
}

export class QUOTE_CREDIT{
  id?: number;
  quoteId?: number;
  referenceNumber?: string;
  primaryStatus?: string;
  primaryStatusDescription?: string;
  secondaryStatus?: string;
  secondaryStatusDescription?: string;
  credit?: Credit;
  threatStatus?: string;
  commonwealthOffset?: boolean;
  monthlyIndexation?: number;
  monthsLapsed?: number;
  paymentPerCredit?: number;
  adjustedExpiryDate?: string;
  adjustedExpiryDateReason?: string;
  quote?: QUOTE_APPLICATION;
  price?: QUOTE_CREDIT_PRICE;
  public constructor() {
    this.price = new QUOTE_CREDIT_PRICE();
  }
}

export class QUOTE_CREDIT_PRICE {
  calculationMethod?: string;
  paymentPerCredit?: number;
  predictedPrice?: number;
  riskPremium?: number;
  deliveryFee?: number;
  totalPrice?: number;
  public constructor() {
    this.paymentPerCredit = 0;
    this.predictedPrice = 0;
    this.riskPremium = 0;
    this.deliveryFee = 0;
  }
}

export class QUOTE_REVIEW {
  id?: number;
  quoteId?: number;
  quoteReviewStatus?: string;
  issuedPreviously?: boolean;
  issuedPreviouslyCommemt?: string;
  previousQuoteReference?: string;
  applicationDetails?: boolean;
  applicationDetailsComment?: string;
  creditReport?: boolean;
  creditReportComment?: string;
  evidenceSubmitted?: boolean;
  evidenceSubmittedComment?: string;
  nswStatutoryApproval?: boolean;
  nswStatutoryApprovalComment?: string;
  commonwealthStatutoryApproval?: boolean;
  commonwealthStatutoryApprovalComment?: string;
  equivalenceStatement?: boolean;
  equivalenceStatementComment?:string
}

export class QUOTE_REVIEW_COMPLETE {
  category?: string;
  reason?: string;
  adjustedDueDate?: string;
  
}

export class QUOTE_MAIL {
  id?: number;
  quoteId?: number;
  mailType?: string;
  mailContent?: string;
  dateMailSent?:string

}

export const QUOTE_MAIL_TYPE = {
  Complete: 'EMLQTERC',
  Incomplete: 'EMLQTERINC',
  Query: 'EMLQTERQRY',
  Cancelled: 'EMLQTERCAN',
  QuoteReady: 'EMLQTERDY',
  QuoteCancelled: 'EMLCANQTE'
}

export enum QueryReasons {
  NSW1 = 1,
  NSW2 = 2,
  NSW3 = 4,
  NSW4 = 8,
  CW1 = 16,
  CW2 = 32,
  CR1 = 64,
  CR2 = 128,
  EQS1 = 256,
  EQS2 = 1024,
  OTH= 2048
}
